const kitchen = {
  '': 'sa',
};

const usLangKitchen = {
  ...kitchen,
};

export default usLangKitchen;
